import React, { ChangeEvent, useCallback, useState } from 'react'
import { Input, message } from 'antd'
import { CustomersService } from '../../customers/services'
import { useParams } from 'react-router-dom'
import { localURLMaker } from '@shared/utils/url-maker'
import { FormType } from '@shared/modules/form/types'
import { AppointmentRoutes } from '../constants'
import { useBackgroundNavigate } from '@shared/hooks'

const { Search } = Input

export const AppointmentSearchCustomer = ({ type = 'create' }: { type?: FormType }) => {
  const navigate = useBackgroundNavigate()
  const params = useParams<{ id?: string; userId?: string }>()
  const [passportSecret, setPassportSecret] = useState<string>('')

  const handlePassportSecretChange = useCallback((event: ChangeEvent<HTMLInputElement>) => {
    setPassportSecret(event.target.value)
  }, [])

  const handleCustomerSecretSearch = useCallback(
    async (passportSecret: string) => {
      message.loading({ key: 'message', content: 'Müştəri axtarılır...' })
      const result = await CustomersService.getOneByPassportSecret(passportSecret)

      if (result.status === 200) {
        message.destroy()
        const id = result.data.id

        if (type === 'create') {
          navigate(localURLMaker(AppointmentRoutes.CREATE_BY_USER_ID, { userId: id }))
        }

        if (type === 'update') {
          navigate(localURLMaker(AppointmentRoutes.UPDATE, { id: params.id || 0, userId: id }))
        }
      } else {
        if (type === 'create') {
          navigate(localURLMaker(AppointmentRoutes.CREATE, {}, { passportSecret }))
        }
        message.error({ key: 'message', content: 'Müştəri tapılmadı...' })
      }
    },
    [navigate, params.id, type],
  )

  return (
    <Search
      value={passportSecret}
      onChange={handlePassportSecretChange}
      onSearch={handleCustomerSecretSearch}
      placeholder='İstifadəçinin FİN Kodunu daxil edin...'
    />
  )
}
